"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("../constants/ActionTypes"));

var initialState = null;

var trialState = function trialState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.default.TRIAL_STATE_RECEIVED:
      return payload;

    case _ActionTypes.default.TRIAL_STATE_REQUESTED:
    case _ActionTypes.default.TRIAL_STATE_FAILED:
      return null;

    default:
      return state;
  }
};

var _default = trialState;
exports.default = _default;
module.exports = exports.default;